import React from "react";
import { Link } from "react-router-dom";
import image1 from "../assets/revolution.jpg";
import image2 from "../assets/abha.jpg";
import image3 from "../assets/image3.png";
import image4 from "../assets/image4.png";
import image5 from "../assets/smart.jpg";
import image6 from "../assets/image6.png";
import image201 from "../assets/image201.png";
import image202 from "../assets/image202.png";
import image203 from "../assets/image203.png";
import image204 from "../assets/image204.png";

const InPatientOutPatientBlog = () => {
  return (
    <div className="min-h-screen w-full font-sans overflow-x-hidden bg-[#d2e5e4] text-black px-4 py-12">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row gap-10">
        {/* Main Blog */}
        <div className="flex-1">
          <img
            src={image2}
            alt="Hospital Workflow"
            className="w-full h-72 object-cover bg-gray-100 border border-gray-300 rounded-lg mb-6"
          />

          <div className="bg-sky-700 text-white text-3xl font-bold py-4 px-6 rounded mb-8">
            Explore how MedOps integrates with ABHA IDs, smart communication,
            security, and AI automation to build the future of Indian healthcare
          </div>

          <div className="space-y-8 text-lg text-black">
            <div>
              <h2 className="text-xl font-semibold mb-2">
                ABHA Integration – Seamless Health Records
              </h2>
              <p>
                MedOps integrates with ABHA IDs, allowing patients’ records to
                move with them— across hospitals, clinics, and labs. This
                ensures continuity of care and reduces duplication of tests.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold mb-2">
                📡 Smart Communication Tools
              </h2>
              <p>
                MedOps connects with WhatsApp, SMS, Gmail, and chatbots to
                simplify communication. Patients get reminders, reports, and
                prescriptions instantly on their mobile phones.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold mb-2">
                🔐 Data Security & Compliance
              </h2>
              <p>
                With ISO 27001 & ISO 9001 certifications, MedOps ensures
                compliance with India’s Digital Personal Data Protection Act
                (DPDP 2023). AI safeguards patient data against unauthorized
                access.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold mb-2">
                🚀 AI + Government Initiatives = Healthcare 2.0
              </h2>
              <p>
                The government’s push for digital health records combined with
                AI automation is creating a new ecosystem. Hospitals adopting
                MedOps are future-proof, aligning with national healthcare
                goals.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold mb-2">Conclusion</h2>
              <p>
                India’s healthcare future is digital, data-driven, and
                AI-powered. With MedOps, hospitals can stay ahead by integrating
                ABHA, automation, and AI for better care, efficiency, and
                compliance.
              </p>
            </div>
          </div>
        </div>

        {/* Sidebar */}
        <div className="w-full md:w-1/3 border-t md:border-t-0 md:border-l border-gray-700 pt-10 md:pt-0 md:pl-8">
          <h3 className="text-xl font-semibold mb-6">Recent Blogs</h3>

          {[
            {
              to: "/voiceprescriptionblog",
              alt: "Voice-Based AI Prescription",
              title:
                "Learn how MedOps uses AI for real-time monitoring, cloud-based records, and decision support to enhance patient care",
              image: image1,
            },
            {
              image: image202,
              alt: "BestHMSforYourHospitalBlog",
              to: "/besthmsforyourhospitalblog",
              title: "Learn more about Best HMS for Your Hospital ",
            },
            {
              to: "/inventorytrackingblog",
              alt: "Inventory Tracking",
              title:
                "Real-Time Inventory Tracking with MedOps: Smarter Stock, Smarter Care",
              image: image6,
            },
            {
              to: "/hospitalpharmacyintegrationblog",
              alt: "Hospital & Pharmacy Modules",
              title:
                "Discover how AI-powered hospital management systems like MedOps reduce paperwork, improve staff efficiency, and enable data-driven decisions",
              image: image5,
            },
            {
              to: "/diagnosticlabintegrationblog",
              alt: "Diagnostic Lab Integration",
              title:
                "AI-Powered Diagnostic Report Generation & Lab Integration",
              image: image4,
            },
            {
              image: image203,
              alt: "CuttingDownPatientReportDeliveryTimewithAIBlog",
              to: "/cuttingdownpatientreportdeliverytimewithaiblog",
              title:
                "Learn more about Cutting Down Patient Report Delivery Time with AI",
            },
            {
              to: "/advancedanalyticscampaignblog",
              alt: "Analytics & Campaign Management",
              title: "Advanced Analytics & Campaign Management",
              image: image3,
            },
            {
              image: image201,
              alt: "PredictiveAnalyticsBlog",
              to: "/predictiveanalyticsblog",
              title: " Learn more about Predictive Analytics ",
            },
            {
              image: image204,
              alt: "MedicineForecastingBlog",
              to: "/medicineforecastingblog",
              title: " Learn more about Medicine Forecasting ",
            },
          ].map((blog, idx) => (
            <div key={idx} className="mb-6">
              <Link
                to={blog.to}
                className="flex flex-col gap-2 hover:opacity-90"
              >
                <img
                  src={blog.image}
                  alt={blog.alt}
                  className="w-full h-54 object-cover bg-gray-100 border border-gray-300 rounded"
                />
                <span className="text-sky-600 font-semibold text-sm">
                  {blog.title}
                </span>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default InPatientOutPatientBlog;
